'use client'

import { createContext, ReactNode, useContext, useEffect, useMemo, useState } from 'react'
import { fetchIp, fetchIpData } from '../utils'

interface AdsContextType {
  isAdsActive: boolean
  setAdsActive: (active: boolean) => void
}

const AdsContext = createContext({
  isAdsActive: false,
  setAdsActive: () => {}
} as AdsContextType)

export const AdsProvider = ({
  children,
  initialActive = false
}: {
  children: ReactNode
  initialActive?: boolean
}) => {
  const [isAdsActive, setAdsActive] = useState(initialActive)

  useEffect(() => {
    const fetchData = async () => {
      try {
        const ip = await fetchIp()
        const data = await fetchIpData(ip)
        setAdsActive(data?.countryCode ? data?.countryCode === 'IN' : true)
      } catch (e) {
        console.error('Error fetching IP data:', e)
        setAdsActive(true)
      }
    }

    fetchData()
  }, [])

  const memoizedValue = useMemo(() => ({ isAdsActive, setAdsActive }), [isAdsActive])

  return <AdsContext.Provider value={memoizedValue}>{children}</AdsContext.Provider>
}

export const useAds = (): AdsContextType => {
  const context = useContext(AdsContext)
  if (context === undefined) {
    throw new Error('useAds must be used within an AdsProvider')
  }
  return context
}
